module.exports = __webpack_public_path__ + "static/media/arbutus-207-min.d64bc26c.jpg";